import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  // Keep disabled initially to preserve no-preloading baseline.
  private readonly enableSelectivePreloading = false;

  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    const shouldPreload = this.enableSelectivePreloading && route.data?.['preload'] === true;
    return shouldPreload ? load() : of(null);
  }
}
